// src/hooks/usePatientSearch

import { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import { searchForPatient } from '../../../store/new-visit/NewVisitThunk'

import { MIN_CHARACTERS_TO_SEARCH } from '../Constants'
import { clearNewVisitSelectedPatient, setNewVisitSelectedPatient } from '../../../store/new-visit/NewVisitActions'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const usePatientSearch = (bookingId) => {
  const dispatch = useDispatch()

  // Search-related states
  const [searchText, setSearchText] = useState('')
  const [forceSearchLoading, setForceSearchLoading] = useState(false)
  const [showSearchResults, setShowSearchResults] = useState(false)
  const [searchResults, setSearchResults] = useState(null)
  const [searchId, setSearchId] = useState(0)
  const [selectedPatient, setSelectedPatient] = useState('')
  const [fullNameError, setFullNameError] = useState('')

  // Selector for search results
  const apiSearchResults = useSelector(
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    (state) => state.newVisitReducer.visits[bookingId.current]?.searchResults,
    (a, b) => {
      if (a?.results?.length === b?.results?.length) {
        for (let i = 0; i < a?.results?.length; i += 1) {
          if (!_.isEqual(a?.results[i], b?.results[i])) {
            return false
          }
        }
      } else {
        return false
      }
      if (b?.searchId !== a?.searchId) return false

      return true
    },
  )

  // Handler: Debounced search input change
  const onChangeSearchInputValue = useCallback(
    _.debounce((value) => {
      const searchValue = value.trim()

      setSearchText(searchValue)
      if (searchValue.length >= MIN_CHARACTERS_TO_SEARCH) {
        const nextSearchId = Math.random()
        setSearchId(nextSearchId)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(searchForPatient(searchValue, bookingId.current, nextSearchId))
        setForceSearchLoading(true)
      } else {
        setSearchResults(null)
      }
    }, 500),
    [dispatch, bookingId],
  )

  // Handler: Search input changed
  const onSearchChanged = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      if (selectedPatient) {
        dispatch(clearNewVisitSelectedPatient(bookingId.current))
        setSelectedPatient('')
      }
      onChangeSearchInputValue(value)
    },
    [onChangeSearchInputValue, selectedPatient],
  )

  // Handler: Patient selected from search results
  const onPatientSelected = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (selectedPatientParam) => {
      dispatch(setNewVisitSelectedPatient(selectedPatientParam, bookingId.current))
      setSelectedPatient(selectedPatientParam)
      if (fullNameError) setFullNameError('')
      setSearchResults(null)
    },
    [fullNameError, dispatch],
  )

  // Handler: Toggle search results visibility
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetShowResults = useCallback((value) => {
    setTimeout(() => {
      setShowSearchResults(value)
    }, 300)
  }, [])

  // Effect: Update search results based on API response
  useEffect(() => {
    if (searchText.length < MIN_CHARACTERS_TO_SEARCH && apiSearchResults?.searchId === searchId) {
      setSearchResults(null)
      setForceSearchLoading(false)
      return
    }
    if (apiSearchResults?.results && apiSearchResults.searchId === searchId) {
      setSearchResults(apiSearchResults.results)
      setForceSearchLoading(false)
    }
  }, [apiSearchResults, searchText.length, searchId])

  // Cleanup: Cancel debounce on unmount
  useEffect(
    () => () => {
      onChangeSearchInputValue.cancel()
    },
    [onChangeSearchInputValue],
  )

  return {
    // States
    searchText,
    forceSearchLoading,
    showSearchResults,
    searchResults,
    selectedPatient,
    fullNameError,
    // Handlers
    onSearchChanged,
    onPatientSelected,
    onSetShowResults,
    // Additional setters if needed
    setFullNameError,
  }
}
